export const activePoliciesListResponseMap = {
  transId: 'transId',
};
